<template>
    <div>
        <template v-if="crud_employee === true && crud_employee !==null">
            <form id="employeeForm" @submit.prevent="addEmployeeTaxDetail">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Employee </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/employees" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Personal Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">2</span>
                            Job Details
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">5</span>
                            Time Off
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">6</span>
                            User Permission
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">7</span>
                            Welcome Options
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-6 offset-md-3">

                                <div class="form-group">
                                    <label class="label block-label"> Tax Filler ? </label>
                                    <label class="radio-holder ml-0">
                                        Yes
                                        <input type="radio" v-model="form.taxFiller" name="taxFiller" value="1">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-holder">
                                        No
                                        <input type="radio" v-model="form.taxFiller" name="taxFiller" value="0">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-group" v-if="form.taxFiller == 1">
                                    <label class="label block-label"> Enter NTN </label>
                                    <input v-model="form.ntn" type="text" name="ntn" class="form-control" :class="{ 'is-invalid': form.errors.has('ntn') }">
                                    <has-error :form="form" field="ntn"></has-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    ntn : '',
                    taxFiller : '',
                    id : this.$route.params.id
                }),
                crud_employee: null
            }
        },
        methods: {
            addEmployeeTaxDetail() {
                this.$Progress.start();
                this.form.post('/api/addEmployeeTaxDetail/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success', 'Employee tax detail added successfully');
                        this.$router.push('/addEmployeePaymentDetail/'+res.data.data.id);
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getEmployeeData() {
                axios.get('/api/editEmployee/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            if(res.data.user.wizard_cycle == 0){
                                this.$router.push('/addEmployeePersonalDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 1){
                                this.$router.push('/addEmployeeBasicDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 2){
                                this.form.taxFiller = (res.data.user.tax_filler==null) ? '0' : res.data.user.tax_filler;
                                this.form.ntn = res.data.user.ntn;
                            }else if(res.data.user.wizard_cycle == 3){
                                this.$router.push('/addEmployeePaymentDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 4){
                                this.$router.push('/addEmployeeTimeoff/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 5){
                                this.$router.push('/addEmployeeUserPermission/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 6){
                                this.$router.push('/addEmployeeWelcome/'+this.$route.params.id);
                            }
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },
        },
        mounted() {
            this.can('crud_employee').then(result => {
                this.crud_employee = result.crud_employee;
            }).then(result => {
                if(this.crud_employee == true){
                    this.getEmployeeData();
                }
            });
        }
    }
</script>
